import React, { useEffect } from 'react';
import styles from '../authentication/components/login.module.scss';

const CategoryPage = (props) => {
  const {
    handleCategory,
    selectedCategory,
    handleCategoryNextBtn,
    categories
  } = props;

  useEffect(() => {
    if (categories?.length === 1) {
      handleCategory(categories?.[0]);
    }
  }, [categories, handleCategory]);

  useEffect(() => {
    if (selectedCategory && categories?.length === 1) {
      handleCategoryNextBtn();
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedCategory, handleCategoryNextBtn]);

  return (<>
    {categories?.length > 1
    ? <div className={styles.login_form_wrapper}
    style={{ borderRadius: '10px', width: 'auto', position: 'absolute', top: '40%', background: 'whitesmoke', padding: '65px' }}>
        <h4 style={{ marginBottom: '5%', fontWeight: 'bold' }}>Please Choose Your Category</h4>
        <div style={{ display: 'flex',
          marginBottom: '5%',
          width: '100%',
          justifyContent: 'center',
          flexDirection: 'column',
          textTransform: 'uppercase',
          fontWeight: 'bold' }}>
          {categories?.map(ele => (
            <div style={{ display: 'flex', padding: '5px' }}>
              <input type="checkbox" checked={selectedCategory === ele}
               onClick={() => { handleCategory(ele); }} style={{ width: '22px', height: '22px', marginRight: '2%' }} />
              <h5>{`${ele.slice(0, 1).toUpperCase()}${ele.slice(1)}`}</h5>
            </div>
          ))}
        </div>
        <button className={styles.nextbtn} onClick={() => { handleCategoryNextBtn(); }}>Next</button>
      </div>
      : ''
    }
          </>
  );
};
export default CategoryPage;
